export const TaskStatus = {
  pending: 'pending',
  inProgress: 'in_progress',
  completed: 'completed',
  skipped: 'skipped',
  postponed: 'postponed',
} as const;

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

export const DayMode = {
  normal: 'normal',
  busy: 'busy',
  travel: 'travel',
  recovery: 'recovery',
  difficult: 'difficult',
  elevation: 'elevation',
  momentDecisif: 'moment_decisif',
  imprevu: 'imprevu',
  transition: 'transition',
} as const;

export type DayMode = (typeof DayMode)[keyof typeof DayMode];

export const RoutineCategory = {
  mental: 'mental',
  sport: 'sport',
  health: 'health',
  work: 'work',
  organization: 'organization',
  growth: 'growth',
  emotion: 'emotion',
  relationship: 'relationship',
  journal: 'journal',
  custom: 'custom',
} as const;

export type RoutineCategory = (typeof RoutineCategory)[keyof typeof RoutineCategory];
